/* gsap.registerPlugin(ScrollTrigger);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollToPlugin } from "gsap/all"; */

import homeAnim from "./home";
import aboutAnim from "./about";
import auditAnim from "./audit";
import sustainabilityAnim from "./sustainability";
import expertiseAnim from "./expertise";
import transmissionAnim from "./transmission";

let homepage = document.querySelector("#homepage");
if (homepage !== null) {
  homeAnim.init();
}

let aboutpage = document.querySelector("#about");
if (aboutpage !== null) {
  aboutAnim.init();
}


let auditPage = document.querySelector("#audit");
if (auditPage !== null) {
  auditAnim.init();
}

let expertisePage = document.querySelector("#expertise");
if (expertisePage !== null) {
  expertiseAnim.init();

}

let transmissionPage = document.querySelector("#transmission");
if (transmissionPage !== null) {
  transmissionAnim.init();

}

let sustainabilityPage = document.querySelector("#sustainability");
if (sustainabilityPage !== null) {
  sustainabilityAnim.init();
  gsap.to(".rail", { xPercent: -50, ease: "none", duration: 30, repeat: -1 });
}


let mentionsPage = document.querySelector("#mentions");
if (mentionsPage !== null) {
      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 1,
        effects: true,
      });
}



let contactPage = document.querySelector('#contact');
if (contactPage !== null) {
  
//H1

      const h1 = document.querySelector("h1.title1");
      if (h1) {
        const h1Split = new SplitText(h1, {
          type: "lines,words,chars",
          linesClass: "split-line",
          charsClass: "js-char",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: h1,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
            markers: false,
          },
        });

        // 1. Animation d'apparition de chaque ligne (comme le span)
        tl.from(h1Split.lines, {
          yPercent: (i) => (i % 2 === 0 ? 100 : -100),
          opacity: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: "power3.inOut",
        });

        // 2. Animation des caractères à l'intérieur de chaque ligne
        h1Split.lines.forEach((line, i) => {
          tl.from(
            line.querySelectorAll(".js-char"),
            {
              opacity: 0,
              yPercent: 20,
              duration: 0.8,
              stagger: 0.04,
              ease: "power3.inOut",
            },
            "-=0.7" // chevauche avec la fin de l'anim de la ligne
          );
        });
      }

      gsap.from("h2", {
        scrollTrigger: {
          trigger: ".contact",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
      });


      gsap.from(".contact .address, .contact .phone, .contact .openhours", {
        scrollTrigger: {
          trigger: ".contact",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
        stagger: 0.2,
      });

}


let menumaincontainer = document.querySelector(".menu-menu-main-container");
let menuhaschildren = document.querySelector(".menu-item-has-children");

// Track if ScrollTrigger is active
let isScrollTriggerActive = false;

gsap.to(".menu-menu-main-container", {
  scrollTrigger: {
    trigger: ".banner",
    start: "bottom top",
    end: "top top",
    toggleActions: "play none none reverse",
    markers: false,
    onEnter: () => {
      isScrollTriggerActive = true;
      console.log(isScrollTriggerActive);
    },
    onEnterBack: () => {
      isScrollTriggerActive = false;
      console.log(isScrollTriggerActive);
    },
  },
  backgroundColor: "#002395", // Change the background color to blue
});

gsap.to(".top-bar", {
  scrollTrigger: {
    trigger: ".banner",
    start: "bottom top",
    end: "top top",
    toggleActions: "play none none reverse",
    markers: false,
    onEnter: () => {
      isScrollTriggerActive = true;
      console.log(isScrollTriggerActive);
    },
    onEnterBack: () => {
      isScrollTriggerActive = false;
      console.log(isScrollTriggerActive);
    },
  },
  backgroundColor: "#002395", // Change the background color to blue
});

// Add hover events for menuhaschildren
menuhaschildren.addEventListener("mouseover", () => {
  if (isScrollTriggerActive) {
    menumaincontainer.classList.add("menu-hovered");

    gsap.to(".menu-menu-main-container", {
      height: "280px",
    });
  } else {
    console.log("ScrollTrigger is not active");
  }
});

menuhaschildren.addEventListener("mouseleave", () => {
  menumaincontainer.classList.remove("menu-hovered");

  gsap.to(".menu-menu-main-container", {
    height: "125px",
  });
});

//menu
document.addEventListener("DOMContentLoaded", function () {
  /**
   * @param {HTMLElement} el
   * @param {string}      attr
   * @param {any}         value
   */
  const setAttr = (el, attr, value) => el.setAttribute(attr, value);

  /** @type {HTMLElement} */
  const topBar = document.querySelector(".top-bar");
  let bluebg = document.getElementById("blue-bg");
  let nav = document.querySelector(".mobile-menu-container");
  let navcontainer = document.querySelector(".menu-menu-main-container-mobile");
  

  if (topBar) {
    /** @type {HTMLElement} */
    const mobileButton = topBar.querySelector("button.menu-toggle");
    console.log(mobileButton);
    /**
     * Au clic sur le bouton mobile, on affiche ou masque le menu :
     * - on ajouter/supprime la classe "toggled" sur la <nav> qui nous servira à masquer/afficher en css
     * - on passe l'attribut "aria-expanded" à true/false
     */
    if (mobileButton) {
      mobileButton.addEventListener("click", function () {
        topBar.classList.toggle("toggled");
        mobileButton.classList.toggle("open");
        bluebg.classList.toggle("slide");
        nav.classList.toggle("show");
        navcontainer.classList.toggle("open");

        if (mobileButton.getAttribute("aria-expanded") === "true") {
          setAttr(mobileButton, "aria-expanded", "false");

          
        } else {
          setAttr(mobileButton, "aria-expanded", "true");

        }
      });
    }
  }
});
